(ns measure.shared-report-download-page.queries
  (:require [common.db.effects.http :refer [parse-response*]]
            [common.queries.http :as qhttp]))

(defn share-token-query [{:keys [share-link-id]}]
  #js {:queryKey #js ["shared-report-download" "share-token-query" share-link-id]
       :queryFn (fn [_ctx]
                  (qhttp/get (qhttp/render :api/dispatcher-get-share-token {} {"share-link/link-id" share-link-id})
                             {:skip-auth-token true}))
       :enabled (some? share-link-id)
       :staleTime js/Infinity})

(defn get-shared-report [{:keys [share-token]}]
  (js/Promise.
   (fn [resolve reject]
     (-> (js/fetch (qhttp/render :measure-api/shared-report-download {})
                   #js {:method "GET"
                        :headers #js {:Authorization share-token
                                      :Content-Type "application/json"}})
         (.then (fn [resp]
                  (if-not (.-ok resp)
                    (reject resp)
                    (resolve (parse-response* :binary+filename resp)))))))))
